import AudioFileIcon from '@mui/icons-material/AudioFile';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import { ListItemText } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { DefaultLayout } from 'layouts';
import { locations } from 'services/routes/locations';
import {
  LibraryContent,
  LibraryGrid,
  LibraryListItemIcon,
  LibraryMenuItem,
  LibraryMenuList,
  LibraryNavLink,
  LibrarySidebar,
} from './styled';

const LibraryLayout = () => {
  const { t } = useTranslation();

  return (
    <DefaultLayout hideFooter hasPlayer>
      <LibraryGrid>
        <LibrarySidebar>
          <LibraryMenuList>
            <LibraryMenuItem>
              <LibraryNavLink to={locations.library.tracks.route}>
                <LibraryListItemIcon>
                  <VideoLibraryIcon />
                </LibraryListItemIcon>
                <ListItemText>{t('library:sidebar:tracks')}</ListItemText>
              </LibraryNavLink>
            </LibraryMenuItem>
            <LibraryMenuItem>
              <LibraryNavLink to={locations.library.projects.route}>
                <LibraryListItemIcon>
                  <AudioFileIcon />
                </LibraryListItemIcon>
                <ListItemText>{t('library:sidebar:projects')}</ListItemText>
              </LibraryNavLink>
            </LibraryMenuItem>
          </LibraryMenuList>
        </LibrarySidebar>
        <LibraryContent>
          <Outlet />
        </LibraryContent>
      </LibraryGrid>
    </DefaultLayout>
  );
};

export default LibraryLayout;
